// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__YMCmr","inlineLinkTheme":"Buttons_inlineLinkTheme__IxevI"};